export default __webpack_public_path__ + "static/media/Pro-17.880d4a9b.png";